module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/374b815c6393f1c3585ddeec83c83f48.svg";